import InfoModuleHeader from './InfoModuleHeader';

interface ProgramProps {
  program?: {
    time?: string;
    description?: string;
  }[];
}

const Program = ({ program }: ProgramProps) => {
  return (
    <>
      {program && (
        <div
          className={`flex flex-col p-[24px] bg-dashed-border w-full font-solina-solina gap-[5px]`}
        >
          <InfoModuleHeader header="PROGRAM" />
          {program.map((programItem, idx) => (
            <span
              key={idx}
              className="font-[200] text-[16px] tablet:text-[16px] laptop:text-[18px] desktop:text-[18px] leading-[37.8px] tracking-[0.03]"
            >
              {programItem.time} – {programItem.description}
            </span>
          ))}
        </div>
      )}
    </>
  );
};

export default Program;
